import { supabase } from '@/lib/supabase';
import {
  GetUsageLogsByDuringTimeParams,
  GetUsageLogsByModelAndTimeParams,
} from './type';

export const getUsageLogs = async () => {
  const { data, error } = await supabase
    .from('usage_logs')
    .select()
    .order('timestamp', { ascending: false });
  if (error) throw error;
  return data;
};

export const getUsageLogsByDuringTime = async ({
  startDate,
  endDate,
}: // page = 0,
// pageSize = 10,
GetUsageLogsByDuringTimeParams) => {
  const { data, error } = await supabase
    .from('usage_logs')
    .select()
    .lte('timestamp', endDate)
    .gte('timestamp', startDate)
    .order('timestamp', { ascending: false });
  // .range(page * pageSize, (page + 1) * pageSize - 1);
  if (error) throw error;
  return data;
};

export const getHourlyUsageLogs = async (
  params: GetUsageLogsByDuringTimeParams
) => {
  const { data, error } = await supabase.rpc('get_hourly_usage_stats', {
    start_date: params.startDate,
    end_date: params.endDate,
    model_filter: params.model,
    workspace_id_filter: params.workspaceId,
  });

  if (error) throw error;
  return data;
};

export const getUsageLogsByModelAndTime = async (
  params: GetUsageLogsByModelAndTimeParams
) => {
  const { data, error } = await supabase.rpc(
    'get_usage_stats_by_model_and_time',
    {
      time_unit: params.time_unit || 'hour',
      ...params,
    }
  );

  if (error) throw error;
  return data;
};
